var link_viewer_default = {
  "fontElementMap": "m8ece",
  "link": "-HNo0",
  "linkInEditor": "-pnuS",
  "linkInViewer": "-NuKl",
  "toolbarUrlContainer": "dBi7S",
  "toolbarUrl": "SekIz",
  "toolbarUrlAnchor": "mYEDE"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
